import styled, { css } from 'styled-components';
import media from 'styled-media-query';

import { IconProps } from './types';

type WrapperProps = Omit<IconProps, 'name'>;

const wrapperModifiers = {
  xsmall: () => css`
    width: 0.8rem;
    height: 0.8rem;

    ${media.greaterThan(`medium`)`
      width: 1rem;
      height: 1rem;
    `}
  `,
  small: () => css`
    width: 1rem;
    height: 1rem;

    ${media.greaterThan(`medium`)`
      width: 1.5rem;
      height: 1.5rem;
    `}
  `,
  medium: () => css`
    width: 1.8rem;
    height: 1.8rem;

    ${media.greaterThan(`medium`)`
      width: 2.4rem;
      height: 2.4rem;
    `}
  `,
  normal: () => css`
    width: 2rem;
    height: 2rem;

    ${media.greaterThan(`medium`)`
      width: 3rem;
      height: 3rem;
    `}
  `,
  large: () => css`
    width: 3rem;
    height: 3rem;

    ${media.greaterThan(`medium`)`
      width: 5rem;
      height: 5rem;
    `}
  `,
  hideOnMobile: () => css`
    ${media.lessThan(`medium`)`
        display: none;
    `}
  `,
  hideOnDesktop: () => css`
    ${media.greaterThan(`medium`)`
        display: none;
    `}
  `,
};

export const Wrapper = styled.span<WrapperProps>`
  ${({ color, margin, size, hideOnMobile, hideOnDesktop }) => css`
    ${!!hideOnMobile && wrapperModifiers.hideOnMobile};
    ${!!hideOnDesktop && wrapperModifiers.hideOnDesktop};

    object > svg {
      ${!!size && wrapperModifiers[size]};
      ${!!margin &&
      css`
        margin: ${margin};
      `};

      path {
        color: ${color || `#99FF00`};
        fill: ${color || `#99FF00`};
      }
    }
  `}
`;
